var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-page"},[_c('h1',{staticClass:"page-title"},[_vm._v("管理员")]),_c('AdminPrizePoolSection'),_c('AdminNodeSection'),_c('AdminShippingSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }